export const parseAllowedSearchParams = () => {
    const params = new URLSearchParams(location.search);
    const result = {};
    for (const [name, value] of params) {
        if (!name.startsWith("utm_"))
            continue;
        result[name] = value;
    }
    return result;
};
